import {takeEvery} from 'redux-saga/effects';
import * as ACTION from './constants';
import * as saga from './saga';

export default function*() {
    yield takeEvery(ACTION.FAILED_COMPLAINT.REQUEST, saga.failedComplaint);
    yield takeEvery(ACTION.FAILED_COMPLAINT.SUCCESS, saga.onFailedComplaintSuccess);
    yield takeEvery(ACTION.FAILED_COMPLAINT.FAILED, saga.onFailedComplaintFailed);
}